import { useState as n, useRef as s, useEffect as l } from "react";
import { useScrollPosition as i } from "./use-scroll-position.js";
const u = 15, a = () => {
  const r = i(), [t, c] = n(null), e = s(r);
  return l(() => {
    const o = r - e.current;
    Math.abs(o) < u || (c(o > 0 ? "down" : "up"), e.current = r);
  }, [r]), t;
};
export {
  a as useScrollDirection
};
